import React, { useState } from "react";
import axiosInstance from "../services/axiosComman";
import { toast } from "react-toastify";

function useEditData() {
  const [isEditLoading, setIsEditLoading] = useState(false);
  const editData = async ({
    url,
    value,
    resetForm = () => {},
    onClose = () => {},
    getData = () => {},
    hasFile= false,
    setSelectedFile=()=>{},
    otherFunction=()=>{},
  }) => {
    setIsEditLoading(true);
    try {
      const res = await axiosInstance.put(url, value);
      if (res.data?.status === true) {
        setIsEditLoading(false);
        resetForm();
        getData();
        onClose();
        if(hasFile){
          setSelectedFile(null)
        }
        toast.success(
          <p className="test-sm">
            {`${
              res.data.msg || res.data.message || "Data updated successfully"
            }`}
          </p>
        );
        otherFunction()
      } else if (res.data?.status === false) {
        setIsEditLoading(false);
        toast.error(
          <p className="test-sm">
            {`${
              res.data.msg || res.data.message || "Data updated unsuccessfully"
            }`}
          </p>
        );
      } else {
        setIsEditLoading(false);
        toast.error(
          <p className="test-sm">
            {`${res.data.msg || res.data.message}` ||
              res.data.error ||
              "Data updated unsuccessfully"}
          </p>
        );
      }
    } catch (err) {
      setIsEditLoading(false);
      toast.error(
        <p className="test-sm">{`${
          err.response.data.msg ||
          err.response.data.message ||
          err.response.data.error ||
          "Data updated unsuccessfully"
        }`}</p>
      );
    } finally {
      setIsEditLoading(false);
    }
  };
  return { isEditLoading, editData };
}

export default useEditData;
